import PropTypes from "prop-types";
import React, { useState } from "react";
import Star from "./Star";

export default function StarRating({ rating, onChange, readOnly = false }) {
  const [hoverRating, setHoverRating] = useState(0);

  const handleMouseEnter = (star) => {
    if (readOnly) return;
    setHoverRating(star);
  };

  const handleMouseLeave = () => {
    if (readOnly) return;
    setHoverRating(0);
  };

  const handleClick = (star) => {
    if (readOnly || typeof onChange !== "function") return;
    onChange(star);
  };

  return (
    <div>
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          isSelected={star <= rating}
          hover={!readOnly && star <= hoverRating}
          onMouseEnter={() => handleMouseEnter(star)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleClick(star)}
        />
      ))}
    </div>
  );
}

StarRating.propTypes = {
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};
